import React from 'react';
import FormSelectField from '../../../../components/form/select-field';
import TextField from '../../../../components/form/text-field/text-field';
import './ssm-redirect-type-number.css';
import FormLabel from '../../../../components/form/label/label';
import FormError from '../../../../components/form/error/error';

const SSMRedirectTypeAndNumber = (props) => {
  const { redirectTypeId, redirectDropDownFormFields, onRedirectTypeSelectionBlur, redirectTypeValue, redirectNumberTextField,
    redirectNumberValue, redirectNumberId, handleOnChangeRedirectNumber, handleOnBlurRedirectNumber, redirectNumberFieldError,
    redirectTypeFieldError } = props;
  return (
    <div className="col-md-12 redirect-type-number-section">
      <div className="row">
        <div className="col-md-3 col-sm-12">
          <FormLabel
            label={redirectDropDownFormFields.label}
            forId={redirectTypeId}
          />
        </div>
        <div className={`col-md-3 col-sm-12 ${redirectTypeFieldError ? 'has-error' : ''}`}>
          <FormSelectField
            id={redirectTypeId}
            disabled={false}
            onBlur={onRedirectTypeSelectionBlur}
            options={redirectDropDownFormFields.options}
            placeholder={redirectDropDownFormFields.placeholder}
            value={redirectTypeValue}
          />
          {(redirectTypeFieldError && redirectDropDownFormFields.errorText) && <FormError errorText={redirectDropDownFormFields.errorText} />}
        </div>
        <div className="col-md-3 col-sm-12">
          <FormLabel
            label={redirectNumberTextField.label}
            forId={redirectNumberId}
          />
        </div>
        <div className={`col-md-3 col-sm-12 ${redirectNumberFieldError ? 'has-error' : ''}`}>
          <TextField
            id={redirectNumberId}
            placeholder={redirectNumberTextField.placeholder}
            value={redirectNumberValue}
            onChange={handleOnChangeRedirectNumber}
            onBlur={handleOnBlurRedirectNumber}
          />
          {(redirectNumberFieldError && redirectNumberTextField.errorText) && <FormError errorText={redirectNumberTextField.errorText} />}
        </div>
      </div>
    </div>
  );
};


export default SSMRedirectTypeAndNumber;
